import { SuspensePage } from '@/shared/ui/layout/SuspensePage';
import { PagesServicesProverkaMain } from './modules/ui/Main';

const ServicesProverkaPage = (
  <SuspensePage>
    <PagesServicesProverkaMain />
  </SuspensePage>
);

export default ServicesProverkaPage;
